import React, { useEffect,  useState } from "react";
import axios from "axios"; 
import BreadcrumbsHeader from "../breadcrumbs/BreadcrumbsHeader";
// import { Link } from "react-router-dom";
import Brands1 from "../brands/Brands1";
import {  FaArrowRight, FaArrowLeft, FaPlay } from "react-icons/fa";
import Slider from "react-slick";
import "aos/dist/aos.css";
import AOS from "aos";

const faqs = [
  {
    question: "What is influencer marketing, and how does it work?",
    answer:
      "Influencer marketing is a strategy where businesses collaborate with individuals who have a substantial online following to promote their products or services. These influencers create content that connects thoroughly with their audience and can drive engagement and sales for brands.",
  },
  {
    question: "Why should I consider influencer marketing for my business?",
    answer:
      "Influencer marketing can help your brand reach a larger and more engaged audience, build trust with potential customers, and generate authentic content. It's an effective way to increase brand visibility and credibility.",
  },
  {
    question: "What is the role of influencer marketing in ISOLS' social media marketing services?",
    answer:
      "Influencer marketing is an integral part of our social media marketing strategy. It involves collaborating with influencers to promote your brand and products to their engaged audience.",
  },
  {
    question: "How can ISOLS help my brand in identifying and connecting with the right influencers?",
    answer:
      "We have a dedicated team that specialises in influencer selection. We'll find influencers whose values align with your brand and who can effectively reach your target audience.",
  },
  {
    question: "What are the benefits of incorporating influencer marketing into my social media strategy?",
    answer:
      "Influencer marketing can add authenticity, credibility, and reach to your brand. It helps build trust with potential customers and provides an effective way to increase brand visibility and goodwill.",
  },
  {
    question: "How do you measure the success of influencer marketing campaigns?",
    answer:
      "ISOLS utilises various metrics to assess influencer marketing campaign success, including engagement rates, reach, click-through rates, and conversion rates. We tailor our approach to your specific campaign goals.",
  },
];

const testimonials = [
  {
    name: "Arpan Ghosh",
    text: "The job which I appointed them was nicely done. The only thing I was concerned about was if they were authentic or not. But everything turned out good and these guys are 100% authentic. Highly recommended by me. I would love to work with these guys in the near future.",
    img: "/images/male-user.png",
  },
  {
    name: "Zeus",
    text: "I took the e-mail marketing service from them. They were highly dedicated towards their work and always kept me updated. After the splendid service they gave me for e-Mail marketing, I asked them for the Search Engine Optimization service as well. It also turned out well and I can actually see a change in my website. The reach of my website seems to be increased and I can also see new audiences checking my website. 5 stars to their work. 😉",
    img: "/images/male-user.png",
  },
  {
    name: "Mr. Badshah",
    text: "I appointed this company for e-mail marketing. To be honest, they did a splendid job. They completely nailed it. I can see the difference in my e-commerce business. If you are looking for a company for the e-mail marketing service, you can choose Digital India Leader blindfolded. 5 stars for there service.",
    img: "/images/male-user.png",
  },
  {
    name: "Sonia Sharma",
    text: "Best in class service. I hired them for a Search Engine Optimization service, they did a splendid job. I can legit see the positive response on my website and can see the reach has been increased in a drastic manner. Cheers to DIL team.",
    img: "/images/female-user.png",
  },
  {
    name: "Jason D. Sealey",
    text: "I hired them for PPC marketing. They provided me with good service. I am happy personalised attitude of dealing. Thanks to these people, my returns has increased and I can finally see a positive response on my website.",
    img: "/images/male-user.png",
  },
];



const InfluencerMarketing = () => {
const [openFAQ, setOpenFAQ] = useState(0);
    const NextArrow = ({ onClick }) => (
      <div className="custom-arrow next-arrow" onClick={onClick}>
        <FaArrowRight />
      </div>
    );
    
    const PrevArrow = ({ onClick }) => (
      <div className="custom-arrow prev-arrow" onClick={onClick}>
        <FaArrowLeft />
      </div>
    );

  const [Influencers, setInfluencers] = useState([]);
  const [loading, setLoading] = useState(true);
  

  useEffect(() => {
      axios
      .get("https://www.isolsgroup.com/new/api/ApiInfluencer", {
        headers: { "X-API-KEY": "ISOLS" },
      })
      .then((res) => {
        console.log("Influencer API:", res.data);
        if (res.data && Array.isArray(res.data.data)) {
          // ✅ Limit to only first 4 records
          const glimpse_influencer = res.data.data
            .filter((item) => item.glimpse_influencer === "1" || item.glimpse_influencer === 1)
            .slice(0, 4);
          setInfluencers(glimpse_influencer);
        } else {
          setInfluencers([]);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching influencers:", err);
        setLoading(false);
      });

    AOS.init({ duration: 1000 });
    
  }, []);

  return (
    <div>
      <BreadcrumbsHeader
        title="Influencer Marketing"
        backgroundImage="/images/breadcrumbs/influencer.jpg"
      />

      {/* Enquiry + Content Section */}
      <section className="section-home-secondary" id="enquire_now">
        <div className="b-home-about relative">
          {/* Vertical Side Title */}
          <div className="vertical-container-top-mod vertical-left home-about-side-title hidden-md">
            <span className="vertical-text-main color-add text-uppercase">
              ISOLS Group
            </span>
            <span className="vertical-text-additional color-add-2 text-uppercase">
              DM
            </span>
          </div>

          <div className="container">
            <div className="row">
              {/* Left Column */}
              <div className="col-xs-12 col-sm-6">
                <div
                  className="b-mod-heading" data-aos="fade-down"
                  style={{
                    visibility: "visible",
                    animationName: "fade-down",
                    marginBottom: "10px",
                  }}
                >
                  <p
                    className="first-heading font-secondary"
                    style={{ fontSize: "20px", fontWeight: 600 }}
                  >
                    INFLUENCER
                  </p>
                  <h2 className="heading-line line-right custom Color customPseudoElBg">
                    <strong>MARKETING</strong>
                  </h2>
                  <p className="second-heading font-additional">
                    UNLEASH YOUR BRAND'S COMPLETE POTENTIAL, PARTNER WITH
                    NEXT-GEN INFLUENCER MARKETING TECHNIQUES!
                  </p>
                  <p className="second-heading font-additional">
                    Dive into the era of unparalleled brand growth and
                    recognition with ISOLS Group. As a vanguard in Social Media
                    Marketing, we're equipped to accelerate your brand’s journey
                    to prominence with groundbreaking strategies and innovative
                    techniques.
                  </p>
                </div>

                <div className="b-text">
                  <p>
                    <strong>ADAPT</strong>
                    <br />
                    True collaboration is rooted in deep understanding. At ISOLS
                    Group, we don’t just listen; we empathize and align with
                    your audience's needs and desires. This empathetic approach
                    forms the backbone of our strategy, allowing us to adapt
                    dynamically to the ever-evolving market trends and consumer
                    preferences.
                  </p>
                  <p>
                    <strong>STRATEGIZE</strong>
                    <br />
                    Celebrate the uniqueness of your brand with our bespoke
                    social media strategies. Our approach is as diverse and
                    dynamic as your brand. We meticulously craft strategies that
                    are in perfect harmony with your brand's goals, paving the
                    way for impactful results and turning your vision into
                    victorious realities.
                  </p>
                  <p>
                    <strong>CAPTIVATE</strong>
                    <br />
                    Let your brand's story be told in a way that mesmerizes. Our
                    team of skilled storytellers weave narratives that capture
                    the essence of your brand, creating a magnetic pull for your
                    audience. Step beyond the conventional – let's script a
                    narrative that is nothing short of extraordinary.
                  </p>
                  <p>
                    <strong>IGNITE</strong>
                    <br />
                    Now is the moment to ignite your brand's potential. With
                    precision and expertise, we implement powerful techniques
                    that launch your brand into the stratosphere. Watch as your
                    brand soars to unprecedented exposure, driving sales and
                    growth that go beyond expectations.
                  </p>
                </div>
              </div>

              {/* Right Column: Form */}
              <div className="col-xs-12 col-sm-6" data-aos="fade-left">
                <div
                  className="footer-form" data-aos="fade-down"
                  id="contact-form"
                  style={{
                    visibility: "visible",
                    animationName: "fade-down",
                  }}
                >
                  <form
                    action="/social-media-marketing"
                    className="form-message-1 text-left b-form-footer"
                    method="post"
                    acceptCharset="utf-8"
                  >
                    <div className="form-results"></div>
                    <h2
                      className="footer-form-title"
                      style={{ color: "#000", fontSize: "20px" }}
                    >
                      SEEK EXPERT'S ADVICE & GET PROPOSAL
                    </h2>

                    {/* Hidden Inputs */}
                    <input
                      type="hidden"
                      name="url"
                      value="/influencer-marketing"
                    />
                    <input type="hidden" name="manager_id" value="" />
                    <input type="hidden" name="pipeline_id" value="14" />
                    <input type="hidden" name="source_id" value="36" />
                    <input
                      type="hidden"
                      name="name"
                      value="New Get Proposal Request Received | ISOLS Group Website | Influencer Marketing Page"
                    />
                    <input
                      type="hidden"
                      id="flowlu_host"
                      value="https://erp.isolsgroup.com/"
                    />
                    <textarea
                      name="nspm"
                      style={{ display: "none" }}
                    ></textarea>

                    {/* Visible Inputs */}
                    <div className="flowlu-row">
                      <input
                        type="text"
                        required
                        placeholder="Your Name*"
                        name="contact_name"
                        className="flowlu-input"
                      />
                      <input
                        type="text"
                        required
                        placeholder="Your Company Name*"
                        name="contact_company"
                        className="flowlu-input"
                      />
                      <input
                        type="text"
                        required
                        placeholder="Email Address*"
                        name="contact_email"
                        className="flowlu-input"
                      />
                      <label>Tentative Influencer Marketing</label>
                      <select
                        className="form-control"
                        style={{
                          color: "#000",
                          border: "1px solid #000",
                          borderRadius: "0px",
                        }}
                      >
                        <option value="">Upto 50K</option>
                        <option value="">50K to 1Lakh</option>
                        <option value="">1Lakh to 2Lakh</option>
                        <option value="">2Lakh to 3Lakh</option>
                        <option value="">3Lakh to 4Lakh</option>
                        <option value="">4Lakh to 5Lakh</option>
                        <option value="">Above 5Lakh</option>
                      </select>
                      <input
                        type="number"
                        required
                        placeholder="Mobile Number"
                        name="contact_phone"
                        className="flowlu-input"
                      />
                      <textarea
                        rows="5"
                        style={{
                          width: "100%",
                          height: "146px",
                          borderRadius: 0,
                        }}
                        name="description"
                        placeholder="Type Your Query"
                        required
                        className="flowlu-input"
                      ></textarea>
                    </div>

                    <div
                      className="flowlu-row flowlu-row-submit"
                      style={{
                        textAlign: "left",
                        marginTop: "10px",
                      }}
                    >
                      <button className="flowlu-submit btn-default-arrow">
                        <FaArrowRight /> Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>

              {/* Full-width Text Below */}
              <div className="col-xs-12 col-sm-12">
                <div className="b-text">
                  <p>
                    <strong>OPTIMIZE</strong>
                  </p>
                  <p>
                    Our partnership extends beyond the initial launch. As your
                    strategic allies, we continually refine and optimize,
                    adapting to outcomes and pioneering new strategies in social
                    media optimization. Gear up for remarkable growth and
                    unforeseen success as we guide your brand towards its zenith.
                  </p>
                  <p>
                    <strong>GLOBAL IMPACT</strong>
                  </p>
                  <p>
                    Empower your brand with ISOLS Group and set the global stage
                    alight. We position your brand to be the pioneer, the talk of
                    the town, and the leader in its domain. Embrace the
                    opportunity to transform your brand into a global phenomenon.
                  </p>
                  <p>
                    <strong>
                      Are you ready to redefine the landscape of Influencer
                      Marketing?
                    </strong>{" "}
                    Team up with ISOLS Group and be part of an exciting journey
                    where your brand's recognition and sales skyrocket. Together,
                    let's sculpt the future of your brand in the world of
                    influencer marketing!
                  </p>
                </div>
              </div>
            </div>

      <div className="row">
      <h2
        className="vc_custom_heading vc_custom_1490112359046"
        style={{
          fontSize: "40px",
          color: "#ff9600",
          lineHeight: 1.2,
          textAlign: "center",
          fontFamily: "Raleway",
          fontWeight: 700,
          fontStyle: "normal",
          padding: "20px 0 22px",
        }}
      >
        INFLUENCER MARKETING OVERVIEW
      </h2>

      <div className="b-services-holder">
        {/* Row 1 */}
        <div className="row">
          <div
            className="col-md-4 col-xs-12 col-sm-4" data-aos="fade-left"
            style={{ visibility: "visible", animationName: "fade-left" }}
          >
            <div className="b-services-item">
              <div className="services-icon">
                <img
                  src="/images/solution-services-icons/social-media-marketing.png"
                  alt="Social Media Marketing icon"
                />
              </div>
              <div className="services-text">
                <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                  AMPLIFY BRAND VISIBILITY AND FORGE EVER-LASTING CONNECTIONS!
                </h6>
                <p>
                  Embark on a journey where your brand doesn't just get noticed;
                  it becomes a sensation. With ISOLS Group, your brand's voice
                  transforms into an echo that resonates in the hearts and minds
                  of your audience. We craft strategic social media campaigns
                  that not only amplify your presence but create meaningful,
                  lasting connections with your audience.
                </p>
              </div>
            </div>
          </div>

          <div
            className="col-md-4 col-xs-12 col-sm-4 wow fadeInDown" data-
            style={{ visibility: "visible", animationName: "fadeInDown" }}
          >
            <div className="b-services-item">
              <div className="services-icon">
                <img
                  src="/images/solution-services-icons/viral-marketing.png"
                  alt="Brand Story icon"
                />
              </div>
              <div className="services-text">
                <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                  ENLIGHTEN THE WORLD WITH YOUR BRAND'S INSPIRING TALE.
                </h6>
                <p>
                  Your brand's story is unique, and we're here to tell it to the
                  world. At ISOLS Group, we weave your brand's journey into a
                  compelling narrative that captures the imagination and drives
                  engagement. Our storytelling expertise turns your brand into a
                  beacon of inspiration, inviting audiences to be part of an
                  unforgettable journey.
                </p>
              </div>
            </div>
          </div>

          <div
            className="col-md-4 col-xs-12 col-sm-4 wow slideInRight"
            style={{ visibility: "visible", animationName: "slideInRight" }}
          >
            <div className="b-services-item">
              <div className="services-icon">
                <img
                  src="/images/solution-services-icons/content-marketing.png"
                  alt="Content Marketing icon"
                />
              </div>
              <div className="services-text">
                <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                  DEVELOP VIRAL CONTENT
                </h6>
                <p>
                  In the realm of digital trends, your brand deserves to be a
                  trailblazer. ISOLS Group is your partner in creating content
                  that not only trends but sets a new standard for virality. Our
                  innovative approach ensures your brand captures the zeitgeist,
                  becoming the talk of the digital town.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Row 2 */}
        <div className="row">
          <div
            className="col-md-4 col-xs-12 col-sm-4 wow slideInLeft"
            style={{ visibility: "visible", animationName: "slideInLeft" }}
          >
            <div className="b-services-item">
              <div className="services-icon">
                <img
                  src="/images/smm.png"
                  alt="Video Marketing icon"
                />
              </div>
              <div className="services-text">
                <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                  IDENTIFY THE RIGHT PLATFORMS
                </h6>
                <p>
                  The digital world is vast, and we know exactly where your
                  brand fits best. ISOLS Group expertly navigates the social
                  media landscape to identify platforms that align perfectly
                  with your brand's message and audience. From Instagram to
                  LinkedIn, we ensure your brand thrives on the right stage.
                </p>
              </div>
            </div>
          </div>

          <div
            className="col-md-4 col-xs-12 col-sm-4 wow fadeInUp"
            style={{ visibility: "visible", animationName: "fadeInUp" }}
          >
            <div className="b-services-item">
              <div className="services-icon">
                <img
                  src="/images/solution-services-icons/video-marketing.png"
                  alt="Influencer Marketing icon"
                />
              </div>
              <div className="services-text">
                <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                  DESIGN
                </h6>
                <p>
                  Captivating design meets strategic marketing at ISOLS Group.
                  Our designs do more than attract – they engage and convert. We
                  craft visual stories that align with your brand's essence,
                  ensuring every post, ad, and campaign contributes to building
                  a stronger, more recognizable brand identity.
                </p>
              </div>
            </div>
          </div>

          <div
            className="col-md-4 col-xs-12 col-sm-4 wow slideInRight"
            style={{ visibility: "visible", animationName: "slideInRight" }}
          >
            <div className="b-services-item">
              <div className="services-icon">
                <img
                  src="/images/solution-services-icons/viral-marketing.png"
                  alt="Viral Marketing icon"
                />
              </div>
              <div className="services-text">
                <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                  CONVERT POTENTIAL LEADS TO SUCCESSFUL CUSTOMERS!
                </h6>
                <p>
                  Turn prospects into passionate brand advocates with ISOLS
                  Group. Our targeted social media strategies are designed to
                  engage and convert your audience into loyal customers. We
                  focus on creating content that resonates, fostering a
                  community around your brand and driving tangible results.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Row 3 */}
        <div className="row">
          <div
            className="col-md-4 col-xs-12 col-sm-4 wow slideInRight"
            style={{ visibility: "visible", animationName: "slideInRight" }}
          >
            <div className="b-services-item">
              <div className="services-icon">
                <img
                  src="/images/ful-funnel.png"
                  alt="Online Reputation Management icon"
                />
              </div>
              <div className="services-text">
                <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                  FULL-FUNNEL MARKETING
                </h6>
                <p>
                  Experience the full spectrum of marketing mastery with ISOLS
                  Group. From raising awareness to driving purchases, our
                  full-funnel approach covers every aspect of the customer
                  journey. We create cohesive campaigns that guide your audience
                  through each stage, culminating in a loyal customer base and
                  unparalleled ROI.
                </p>
              </div>
            </div>
          </div>

          <div
            className="col-md-4 col-xs-12 col-sm-4 wow slideInRight"
            style={{ visibility: "visible", animationName: "slideInRight" }}
          >
            <div className="b-services-item">
              <div className="services-icon">
                <img
                  src="/images/solution-services-icons/email-marketing.png"
                  alt="Email Marketing icon"
                />
              </div>
              <div className="services-text">
                <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                  NATIVE
                </h6>
                <p>
                  Seamlessly integrate your brand into the daily lives of your
                  audience with our native advertising expertise. ISOLS Group
                  crafts authentic and engaging content that resonates within
                  the native environment of each platform, ensuring your brand
                  message is not just seen, but felt and remembered.
                </p>
              </div>
            </div>
          </div>

          <div
            className="col-md-4 col-xs-12 col-sm-4 wow slideInRight"
            style={{ visibility: "visible", animationName: "slideInRight" }}
          >
            <div className="b-services-item">
              <div className="services-icon">
                <img
                  src="/images/solution-services-icons/payonclick.png"
                  alt="Pay Per Click icon"
                />
              </div>
              <div className="services-text">
                <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                  AD PLATFORMS
                </h6>
                <p>
                  Dominate the digital landscape with ISOLS Group's strategic ad
                  placements. Our expert team leverages the power of leading
                  social media platforms to maximize your brand's reach and
                  impact. From crafting compelling ads to optimizing campaigns
                  for peak performance, we ensure every ad click contributes to
                  your brand's success.
                </p>
              </div>
            </div>
          </div>
        </div>
        </div>
        </div>
        </div>
        </div>
      </section>

      {/* Influencer Network Section */}
      <section className="section-about1 sectionn" style={{ paddingBottom: "80px" }}>
        <div className="container">
          <h2
            style={{
              fontSize: "25px",
              color: "#ff9600",
              lineHeight: 1.2,
              textAlign: "center",
              fontFamily: "Raleway",
              fontWeight: 700,
              textTransform: "uppercase",
              paddingBottom: "30px",
            }}
          >
            Glimpse of influencer network
          </h2>

          <div className="row">
            {/* Example influencer card */}
            {/* Influencer Cards */}
            {loading ? (
              <p className="text-center">Loading influencers...</p>
            ) : Influencers.length > 0 ? (
              Influencers.map((inf, index) => (
            <div className="col-lg-3 col-md-3 col-sm-3">
              <div className="influence">
                <div className="influ text-center"> 
                  <a
                    href={inf.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={`https://www.isolsgroup.com/uploaded-images/gallery/${inf.image}`}
                      alt={inf.name}
                    />
                  </a>
                </div>
                <div className="influence1">
                  <p>
                    <strong>Name :</strong> Anita Sharma
                  </p>
                  <p>
                    <strong>Category :</strong> Micro
                  </p>
                  <p>
                    <strong>Industry :</strong> Digital Creator
                  </p>
                  <p>
                    <strong>Followers :</strong> 87.5K
                  </p>
                </div>
              </div>
            </div>
            ))
            ) : (
              <p className="text-center">No influencers available.</p>
            )}
          </div>

          <div className="col-lg-12">
            <div className="exploree">
              <a
                href="influencer-network"
                className="btn btn-default-arrow btn-sm"
              >
                <FaArrowRight /> Explore more
              </a>
            </div>
          </div>

          <div className="row">
            <div className="p-sz">
              <p style={{ fontSize: "17px", textAlign: "center" }}>
                In the vibrant and ever-shifting landscape of social media,
                where your audience finds its voice and passions, standing out
                as a brand isn't just important — it's essential. As the digital
                world revolves around new trends and evolving interests, your
                brand deserves a partner who's not only proficient but also
                revolutionary. ISOLS is where unparalleled social media
                marketing expertise transforms your brand from just another name
                into a standout sensation for many. We're not just keeping up
                with the digital evolution but making waves and turning heads.
                Partner with ISOLS for a social media journey that transforms
                challenges into opportunities, where every day is an opportunity
                to make your brand's dynamic potential the immortal powerhouse
                of the online world.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Video Play Section */}
      <section className="section-aboutt">
        <div className="container">
          <div className="b-home-video-block">
            <div className="container-fluid">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 left-side wow slideInLeft">
                <div className="b-video-holder">
                  <a
                    className="video-image playVideo1"
                    href="#"
                    data-toggle="modal"
                    data-target="#myModal"
                    data-title="#"
                  >
                    <FaPlay className="demo-icon play-icon" /><br></br>
                    <span className="video-title">play the video</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
<div class="clearfix"></div>
      <section>
    <div className="container" style={{ padding: "60px 0" }}>
  <div className="row">

    {/* LEFT SIDE – FAQ */}
    <div className="col-lg-6 col-md-12">
      <section className="faq-section">
        <h2 className="faq-title">ASK YOUR QUERIES?</h2>
        <p className="faq-subtitle">SEO FAQs</p>

        <div className="faq-box">
          {faqs.map((item, index) => (
            <div
              key={index}
              className={`faq-item ${openFAQ === index ? "active" : ""}`}
              onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
            >
              <div className="faq-question">
                <span className="faq-icon">
                  {openFAQ === index ? "✖" : "➕"}
                </span>
                {item.question}
              </div>

              {openFAQ === index && (
                <div className="faq-answer">{item.answer}</div>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>

    {/* RIGHT SIDE – TESTIMONIALS */}
    <div className="col-lg-6 col-md-12">
      <section className="testimonial-section">
  <h2 className="testimonial-title">What our clients say about us</h2>

  <Slider
    dots={true}
    infinite={true}
    speed={500}
    slidesToShow={1}
    slidesToScroll={1}
    autoplay={true}
    autoplaySpeed={3000}
    arrows={true}
    nextArrow={<NextArrow />}
    prevArrow={<PrevArrow />}
  >
    {testimonials.map((item, i) => (
      <div key={i} className="testimonial-card">
        <img src={item.img} alt="" className="testimonial-img" />
        <h4 className="testimonial-name">{item.name}</h4>
        <p className="testimonial-text">{item.text}</p>
      </div>
    ))}
  </Slider>
</section>

    </div>

  </div>
</div>

    </section>   


<section
      className="section-about1 sectionn"
      style={{ paddingBottom: "100px" }}
    >
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12">
            <h2
              style={{
                fontSize: "25px",
                color: "#ff9600",
                lineHeight: 1.2,
                textAlign: "center",
                fontFamily: "Raleway",
                fontWeight: 700,
                fontStyle: "normal",
                padding: "0 0 30px 0",
                textTransform: "uppercase",
              }}
              className="vc_custom_heading vc_custom_1490112359046"
            >
              What Our Client Feel About Us
            </h2>

            <div className="row">
              <div className="col-lg-4">
                <iframe
                  width="100%"
                  height="310"
                  src="https://www.youtube.com/embed/ofWi6TePZQo"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="Client Feedback 1"
                ></iframe>
              </div>

              <div className="col-lg-4">
                <iframe
                  width="100%"
                  height="310"
                  src="https://www.youtube.com/embed/3iJH9el9dzQ"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="Client Feedback 2"
                ></iframe>
              </div>

              <div className="col-lg-4">
                <iframe
                  width="100%"
                  height="310"
                  src="https://www.youtube.com/embed/Hfh01auRGAw"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="Client Feedback 3"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
      {/* Brands Section */}
      <Brands1 />
    </div>
  );
};

export default InfluencerMarketing;
